import { ActionType, ProTable } from "@ant-design/pro-components";
import { Button, Select, message } from "antd";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import UUIDComponent from "../../components/UUIDComponent";

export default function PopupFeedback() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "用户id",
            dataIndex: "userId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "反馈内容",
            dataIndex: "content",
            align: "center",
            search: false,
            render: (value: any) => {
                // 如果是字符串，尝试解析为JSON数组
                if (typeof value === 'string') {
                    try {
                        const parsedValue = JSON.parse(value);
                        if (Array.isArray(parsedValue)) {
                            value = parsedValue;
                        }
                    } catch (e) {
                        // 解析失败，保持原值
                    }
                }

                // 检查是否为数组
                if (!Array.isArray(value) || value.length === 0) return value || '-';

                return (
                    <div style={{ textAlign: 'left' }}>
                        {value.map((item, index) => {
                            const [title, content] = item || [];
                            // 如果标题和内容都为空，则不显示该项
                            if (!title && !content) return null;

                            return (
                                <div key={index} style={{ marginBottom: '8px' }}>
                                    <div>标题：{title || '无标题'}</div>
                                    <div>内容：{content || '无内容'}</div>
                                </div>
                            );
                        })}
                    </div>
                );
            }
        },
        {
            title: "反馈状态",
            dataIndex: "status",
            align: "center",
            search: true,
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder='请选择状态'
                    options={[
                        { label: "待处理", value: 'ENABLE' },
                        { label: "已处理", value: 'DISABLE' },
                    ]}
                />
            ),
            render: (text: string) => {
                switch (text) {
                    case "ENABLE":
                        return <span style={{ color: 'orange' }}>待处理</span>;
                    case "DISABLE":
                        return <span style={{ color: 'green' }}>已处理</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
        },
        {
            title: "反馈时间",
            dataIndex: "createAt",
            align: "center",
            valueType: "dateRange",
            hideInTable: true,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => {
                if (record.status === 'ENABLE') {
                    return <Button style={{ color: '#58CCE0' }} type="text" onClick={() => changeStatus(record)}>处理</Button>;
                } else if (record.status === 'DISABLE') {
                    return <Button style={{ color: '#F3C017' }} type="text" onClick={() => changeStatus(record)}>取消处理</Button>;
                }

                return null;
            },
        }
    ];

    const changeStatus = async (item: any) => {
        const data: any = await jsonRequest.put(`/back/health-feedback/change-status/pop-up/${item.id}`, {})
            .then((resp: any) => resp.json());
        if (data?.code === 0) {
            tableRef.current?.reload();
            message.success("处理成功");
        } else {
            message.error(data?.msg || "处理失败");
        }
    };

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/health-feedback/page/pop-up", {
            currentPage: params.current,
            pageSize: params.pageSize,
            queryBeginDate: params?.createAt?.[0],
            queryEndDate: params?.createAt?.[1],
            status: params.status,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>弹窗反馈</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
        />
    </>;
}